import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import NuovaEmail from '../Components/NuovaEmail';
import RiepilogoOTPEmail from '../Components/RiepilogoOTPEmail';
import { /*logout,*/ emailRegex } from '../Utils/Utility';
import { UpdateEmailCtrl } from '../Controllers/Account/UpdateEmailCtrl';
import { ERRORMESSAGE } from '../Constants.js';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
/*import { loader } from '../Utils/Utility';*/

class ModificaEmailSteps extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            newMail: '',
            confMail: '',
            oldMail: '',
            obfsMail: '',
            msgEmail:'',
            msgMailConf:'',
            disableButton: true,
            disableButtonNewMail: true,
            errorOldMail: false,
            emailValid: false,
            confValid: false,
            errorConf:false,
            errorNew:false,
            error: false,
            dataOTP: false,
            status: '',
            showTimeoutModal: false
        }
        this.updateMail = this.updateMail.bind(this);
        this.setNewMail = this.setNewMail.bind(this);
        this.setConfirmMail = this.setConfirmMail.bind(this);
    }

    nextStep = () => {
        const { step } = this.state
        this.setState({
            step: step + 1
        })
    }

    prevStep = () => {
        const { step } = this.state
        this.setState({
            step: step - 1
        })
    }

    firstStep = () => {
        this.setState({
            step: 1,
            newEmail: '',
            confirmNewEmail: ''
        })
    }

    /***************************************************/
    
    setNewMail(e) {
        var email = e.target.value;
        var old = this.state.oldMail;
        this.setState({
            newMail: email
        },
            this.validNewMail(email, old),
        )
    }

    setConfirmMail(e) {
        var confMail = e.target.value;
        var emailValid = this.state.emailValid;
        var newMail = this.state.newMail;
        this.setState({
            confMail: confMail
        },
            this.compareNewAndConf(newMail, confMail, emailValid)
        )
    }

    compareNewAndConf(newMail, confMail, emailValid) {
        /*var emailValid = emailValid;*/
        if (newMail !== confMail) {
            this.setState({
                errorConf: true,
                confValid: false,
                msgMailConf: ERRORMESSAGE.msgconfirmemail
            }, this.activeBtn(emailValid, false))
        } else {
            this.setState({
                errorConf: false,
                confValid: true,
                msgMailConf: ''
            }, this.activeBtn(emailValid, true))
        }
    }

    compareNewAndOld(newPwd, oldPwd) {
        var emailValid = this.state.emailValid;
        var confValid = this.state.confValid;

        if (newPwd === oldPwd) {
            this.setState({
                errorNew: true,
                emailValid: false,
                msgEmail: ERRORMESSAGE.msgpassold
            }, this.activeBtn(emailValid, confValid))
        }
    }

    activeBtn(emailValid, confValid) {

        if (emailValid && confValid) {
            this.setState({
                disableButtonNewMail: false
            })
        } else {
            this.setState({
                disableButtonNewMail: true
            })
        }
    }

    validNewMail(email, old) {
        var msg = '';
        var mail = false;
        var confMail = this.state.confMail;

        if (email === '') {

            msg = ERRORMESSAGE.msgblank;
            mail = false;

        } else if (email === old) {

            msg = ERRORMESSAGE.msgemailold;
            mail = false;

        } else if (email !== '' && !emailRegex.test(email)) { // Validazione mail

            msg = ERRORMESSAGE.msgemail;
            mail = false;

        } else if (email !== '' && emailRegex.test(email)) {

            msg = '';
            mail = true;

        }

        this.setState({
            msgEmail: msg,
            emailValid: mail,
            errorNew: !mail
        }, this.compareNewAndConf(email, confMail, mail))
    }
    
    /***************************************************/

    updateMail() {
        const self = this;
        UpdateEmailCtrl(function (data, statusOK) {
            self.setState({ 
                status: statusOK 
            }, function() {
                this.nextStep();
            })
        }, function (statusKO) {
                if(statusKO === 500 || statusKO === 400 || statusKO === 404 || statusKO === 403){
                    self.setState({
                        status: statusKO
                     }, function() {
                        this.nextStep();
                    })  
                } else if (statusKO === 401) {
                    self.setState({
                        showTimeoutModal: true
                    })
                } 
            
        }, this.state)
    }

    

    form(step) {

        const { email, newEmail, confirmNewEmail, msgemail, msgemail2, error, disableButtonNewMail, status, obfsMail, msgEmail, msgMailConf, showTimeoutModal } = this.state;
        const values = { email, newEmail, confirmNewEmail, msgemail, msgemail2, error, disableButtonNewMail, status, obfsMail,  msgEmail, msgMailConf, showTimeoutModal };
        // eslint-disable-next-line default-case
        switch (step) {

            case 1:
                return <NuovaEmail
                    nextStep={this.nextStep}
                    setNewMail={this.setNewMail}
                    setConfirmMail={this.setConfirmMail}
                    updateMail={this.updateMail}
                    values={values}
                />
            case 2:
                return <RiepilogoOTPEmail
                    firstStep={this.firstStep}
                    values={values}
                />

        }
    }

    componentWillMount() {
        var email = JSON.parse(sessionStorage.getItem('dataWelcome')).email !== undefined ? JSON.parse(sessionStorage.getItem('dataWelcome')).email : '';
        var obfEmail = '';
        if(email !== '' && email !== undefined){
            var res = email.split("@");
            var user=res[0];
            var toChange=email.substring(1, user.length);
            var newStr = '';
            var i=0;
            for(i;i<toChange.length;i++){
                newStr+="*";
            }
            var host=res[1];
            obfEmail = user[0]+newStr+'@'+ host;
        }

        this.setState({
            oldMail: email !== '' && email !== undefined ? email : '',
            obfsMail: obfEmail
        })
    }

    render() {
        const { step } = this.state;


        return (

            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>

                    <Box className='contentbox'>

                        <Box direction='row'>
                            {this.form(step)}
                        </Box>
                    </Box>

                </Box>
            </Box>
        )
    }

}
export default ModificaEmailSteps;